<p-dialog
  header="Επαναφορά κωδικού"
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '90vw', maxWidth: '500px' }"
>
  <eo-form
    #eoForm
    [config]="formConfig"
    [submitButtonLabel]="submitLabel"
    [submitButtonLoading]="isLoading()"
    [validate]="true"
    submitButtonStyleClass="p-button-primary"
    (formSubmit)="onSubmit($event)"
    class="p-fluid"
  ></eo-form>
</p-dialog>
